import { ClickAwayListenerV2 } from "@nova/component-click-away-listener"
import { zIndex } from "@nova/constants"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    closeFullPanel,
    selectActiveSearchPanelPlugin,
    selectRecentSearchesPanelOpen,
    setSearchInputFocused,
} from "../slice"
import { OverviewSearchBar } from "./OverviewSearchBar"
import { OverviewSearchDropdown } from "./OverviewSearchDropdown"
import { OverviewSearchPanel } from "./OverviewSearchPanel"

export const OverviewSearchArea = () => {
    const dispatch = useAppDispatch()
    const activePlugin = useAppSelector(selectActiveSearchPanelPlugin)
    const isRecentSearchPanelOpen = useAppSelector(selectRecentSearchesPanelOpen)
    return (
        <ClickAwayListenerV2
            portalId="portal"
            onClickAway={() => {
                dispatch(setSearchInputFocused(false))
                if (activePlugin || isRecentSearchPanelOpen) {
                    dispatch(closeFullPanel())
                }
            }}
        >
            <OverviewSearchPanel />
            <div className="relative" style={{ zIndex: zIndex.SidePanel }}>
                <OverviewSearchBar />
                <OverviewSearchDropdown />
            </div>
        </ClickAwayListenerV2>
    )
}
